export const filterCurrNav = (pathname: string, navs) => {
  if (!Array.isArray(navs)) return { _selKey: '', _openKey: '' };
  let _selKey = '';
  let _openKey = '';
  navs.forEach((nav) => {
    if (nav?.children?.length) {
      nav.children.forEach((child) => {
        if (child.children?.length) {
          child.children.forEach((grandChild) => {
            if (pathname.startsWith(grandChild.path)) {
              _selKey = grandChild.path;
              _openKey = nav.title;
            }
          });
        } else {
          if (pathname.startsWith(child.path)) {
            _selKey = child.path;
            _openKey = nav.title;
          }
        }
      });
    } else {
      if (pathname.startsWith(nav.path)) {
        _selKey = nav.path;
      }
    }
  });
  return { _selKey, _openKey };
};
